export { FREE_TIER_PAGE_SETUP_LIMIT } from 'aeo-schema-generator-shared/utils'
import { FREE_TIER_PAGE_SETUP_LIMIT } from 'aeo-schema-generator-shared/utils'
export const BILLING_PLANS_PATH = '/settings/billing?section=plans#subscription-plans'

/*
  What the page detail says beside Write it when the page is the account's
  free first page. The report's card says the same sentence under Put it
  live (HubSpotReport.tsx); a test holds the two together. It names the paid
  HubSpot plan, as every promise to change somebody's page does.
*/
export const FREE_FIRST_PAGE_LINE = 'Your first page is free, with no card. Copy the code to install it yourself.'

/*
  What the page detail says beside See plans when the page would have been
  the account's free first page and the team's tries for the day are used
  up. The report's card begins its own sentence for that with these words
  and then says what its Put it live button does (HubSpotReport.tsx). The
  page detail has no such button, so it stops where the report turns to it.
  A test holds the two together.
*/
export const FREE_PAGES_TAKEN_LINE = "Today's free pages are taken. Try again tomorrow."

export interface PageSetupEntitlements {
  schemaCostMode?: string | null
  canGenerateSchema?: boolean | null
  generatedPagesUsed?: number | null
  generatedPageLimit?: number | null
  isPaidSubscriber?: boolean | null
}

export interface FreeTrialPageSetupState {
  isFreeTrial: boolean
  isAtLimit: boolean
  used: number
  limit: number
  remaining: number
}

export function getFreeTrialPageSetupState(
  entitlements?: PageSetupEntitlements | null
): FreeTrialPageSetupState {
  const isFreeTrial =
    entitlements?.schemaCostMode === 'free_trial_limit' &&
    entitlements?.isPaidSubscriber !== true
  const used = Math.max(0, Number(entitlements?.generatedPagesUsed ?? 0))
  const limit = isFreeTrial
    ? FREE_TIER_PAGE_SETUP_LIMIT
    : Math.max(0, Number(entitlements?.generatedPageLimit ?? 0))
  const remaining = Math.max(0, limit - used)

  return {
    isFreeTrial,
    isAtLimit: isFreeTrial && entitlements?.canGenerateSchema === false,
    used,
    limit,
    remaining,
  }
}

export function isFreeTrialGeneratedPageLimitError(error: unknown): boolean {
  const maybeError = error as {
    code?: string
    response?: {
      data?: {
        code?: string
        error?: string
        message?: string
      }
    }
    message?: string
  }
  const code = maybeError?.code || maybeError?.response?.data?.code
  const message =
    maybeError?.response?.data?.error ||
    maybeError?.response?.data?.message ||
    maybeError?.message ||
    ''

  return (
    code === 'free_trial_generated_page_limit' ||
    (/free trial/i.test(message) &&
      /page setup|page generation|generated page/i.test(message))
  )
}
